import React, { useContext, useState } from "react"
import { Dimensions, View } from "react-native"
import styles from "./styles"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { Button } from "@Components/CustomButton/Button"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import { InputGroup } from "@Components/Input/InputGroups"
import { MultipleDaySelector } from "@Components/FollowUp/Toolbox/MultipleDaySelector"
import { CustomDropDownPicker } from "@Components/FollowUp/Toolbox/CustomDropdownPicker"
import { isNumber } from "@Utils/utils"
import { useRecoilState } from "recoil"
import { reminderPayloadAtom } from "@Recoil/Atom/reminderAtom"
import { ReminderContext } from "@Providers/ReminderProvider"

const frequencies = [
    { id: 1, label: "Jour", value: "day" },
    { id: 2, label: "Semaine", value: "week" },
    { id: 3, label: "Mois", value: "month" },
    { id: 4, label: "An", value: "year" }
]

const { width, height } = Dimensions.get("screen")

export const ModalCreateRecurrence = (props) => {
    const { toggleModal, openModal } = props
    const { reminder, setReminder } = useContext(ReminderContext)
    const [reminderFrequency, setReminderFrequency] = useState(reminder?.recurrence?.frequency)
    const [isDropDownOpen, setIsDropDownOpen] = useState(false)
    const disableCreationBtn = reminder?.recurrence?.frequency <= 0 || !reminder?.recurrence?.frequencyUnit

    return (
        <CustomBottomModal toggleModal={toggleModal} open={openModal}>
            <View style={{ height: "100%" }}>
                <BreeSerifText textAlign={"center"} fontSize={RFValue(23)} color={baseColors.black}>
                    Récurrence du rappel
                </BreeSerifText>

                <Spacer height={20} />

                <InputGroup
                    validation_message="Nombre positif requis"
                    value={reminder?.recurrence?.frequency?.toString() ?? 1}
                    onChange={(txt) =>
                        setReminder((old) => ({
                            ...old,
                            recurrence: { ...reminder.recurrence, frequency: txt }
                        }))
                    }
                    valid={isNumber(reminder?.recurrence?.frequency) && reminder?.recurrence?.frequency > 0}
                    label="Fréquence de répétition"
                />

                <Spacer height={20} />

                <CustomDropDownPicker
                    setIsDropDownOpen={setIsDropDownOpen}
                    defaultValue={reminder?.recurrence?.frequencyUnit}
                    data={frequencies}
                    placeholder="Sélectionner un type de fréquence"
                    handleChange={(value) => {
                        setReminderFrequency(value)
                        console.log({ value })
                        if (value != "week") {
                            setReminder((old) => ({
                                ...old,
                                recurrence: { ...reminder.recurrence, frequencyUnit: value, recurrenceDays: [] }
                            }))
                        } else {
                            setReminder((old) => ({
                                ...old,
                                recurrence: { ...reminder.recurrence, frequencyUnit: value }
                            }))
                        }
                    }}
                />

                {!isDropDownOpen && reminderFrequency === "week" && (
                    <View style={styles.formContainer}>
                        <OpenSansText fontSize={RFValue(16)} defaultFontFamily={baseFontFamily.OpenSansSemiBold}>
                            Rappels le
                        </OpenSansText>
                        <Spacer height={20} />
                        <MultipleDaySelector
                            allowWeekendDay
                            selected={reminder?.recurrence?.recurrenceDays}
                            handleChange={(value) =>
                                setReminder((old) => ({
                                    ...old,
                                    recurrence: { ...reminder.recurrence, recurrenceDays: value }
                                }))
                            }
                        />
                        <Spacer height={50} />
                    </View>
                )}

                <View style={{ position: "absolute", width: width - 40, bottom: 0 }}>
                    <Button
                        disabled={disableCreationBtn}
                        onPress={toggleModal}
                        text="Valider"
                        width="70%"
                        height={RFValue(50)}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </View>
        </CustomBottomModal>
    )
}
